module.exports = __webpack_public_path__ + "img/photo-coral.ddfe8f5b.jpg";